function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12,
  transform: "matrix(-1 0 0 1 24 0)",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M13.1161 16.877C13.2788 17.0398 13.5426 17.0398 13.7053 16.877L14.2946 16.2878C14.4573 16.1251 14.4573 15.8613 14.2946 15.6985L10.5961 12L14.2946 8.3015C14.4573 8.13878 14.4573 7.87497 14.2946 7.71225L13.7053 7.12299C13.5426 6.96027 13.2788 6.96027 13.1161 7.12299L8.53461 11.7045C8.45287 11.7862 8.4122 11.8934 8.41257 12.0006C8.41248 12.1073 8.45315 12.2141 8.53461 12.2956L13.1161 16.877Z",
  fill: "white"
});

var SvgChevronLeftInCircleFill = function SvgChevronLeftInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronLeftInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left-in-circle-fill.3e0c2c12.svg";
export { ForwardRef as ReactComponent };